import { Component, type ReactNode } from "react";

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  failed: boolean;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  public state: ErrorBoundaryState = { failed: false };

  public static getDerivedStateFromError(): ErrorBoundaryState {
    return { failed: true };
  }

  public render(): ReactNode {
    if (this.state.failed) {
      return (
        <main className="auth-shell" role="alert">
          <section className="auth-card">
            <p className="eyebrow">Base Hormonal</p>
            <h1>Não foi possível renderizar esta visualização.</h1>
            <p>
              Nenhum detalhe interno foi exposto. Recarregue a visualização para tentar novamente.
            </p>
            <button type="button" onClick={() => this.setState({ failed: false })}>
              Tentar novamente
            </button>
          </section>
        </main>
      );
    }
    return this.props.children;
  }
}
